var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt005ColorDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sql_color_diamond",
    transform: "translate(-620 -717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-ot-pathwayNodeBackground-ot-pc-PT005-pc-",
    "data-name": "-ot-pathwayNodeBackground-ot-pc-PT005-pc-",
    transform: "translate(620 765) rotate(-45)",
    fill: "#e6ecff",
    stroke: "#093ce9",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 67.882,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 59.882,
    height: 59.882,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1889",
    "data-name": "Group 1889",
    transform: "translate(620 717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M0,0H39.931V39.931H0Z",
    transform: "translate(27.731 27.815)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_-ot-pathwayNodeIcon-ot-pc-PT005-pc-",
    "data-name": "-ot-pathwayNodeIcon-ot-pc-PT005-pc-",
    d: "M6071.578-7228.284a16.009,16.009,0,0,1,0-22.639,16.006,16.006,0,0,1,22.639,0,16.005,16.005,0,0,1,0,22.639,15.952,15.952,0,0,1-11.318,4.689A15.959,15.959,0,0,1,6071.578-7228.284Zm11.492-11.445,4.392,6.582h2.652v-1.348h-1.738l-3.719-5.477a3.905,3.905,0,0,0,3.136-3.907c0-2.652-2.218-3.737-4.6-3.737-1.231,0-2.486.29-3.715.29a9.381,9.381,0,0,1-2.217-.29v1.277l1.978.244v11.6h-1.978v1.348h5.761v-1.348h-2.289v-5.234Zm-1.085-1.277-1.256-.025v-5.063a22.276,22.276,0,0,1,2.486-.171c1.685,0,3.013.723,3.013,2.557,0,1.541-1.133,2.7-4.065,2.7Z",
    transform: "translate(-6034.778 7287.224)",
    fill: "#1243e9",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "_-ot-pathwayNodeBackground-ot-pc-PT005-pc--2",
    "data-name": "-ot-pathwayNodeBackground-ot-pc-PT005-pc-",
    transform: "translate(620 765) rotate(-45)",
    fill: "#e6ecff",
    stroke: "#093ce9",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 67.882,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 59.882,
    height: 59.882,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1888",
    "data-name": "Group 1888",
    transform: "translate(620 717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M0,0H40V40H0Z",
    transform: "translate(28 28)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_-ot-pathwayNodeIcon-ot-pc-PT005-pc-_",
    "data-name": "-ot-pathwayNodeIcon-ot-pc-PT005-pc-  ",
    d: "M2,30.667H35.333V24H2Zm3.333-5H8.667V29H5.333ZM2,4v6.667H35.333V4ZM8.667,9H5.333V5.667H8.667ZM2,20.667H35.333V14H2Zm3.333-5H8.667V19H5.333Z",
    transform: "translate(29.333 30.667)",
    fill: "#093ce9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt005ColorDiamond);
export default __webpack_public_path__ + "static/media/PT005_color_diamond.2160d7b76e66826bdf304b13e704e9a1.svg";
export { ForwardRef as ReactComponent };